export enum BackhaulStatus {
    Open = 0,
    Completed = 1
}

export const BackhaulStatusMetadata = {    
    '0': {
        display: 'Open',
        value: 0
    },
    '1': {
        display: 'Completed',
        value: 1
    }
};
